// Règle d'aiguillage de /versements (adresse unique des « Site links » Stripe,
// 28/09/2026) : association connectée → son onglet Versements ; utilisateur
// connecté → /wallet ; personne → null (la page propose de choisir).
export const DEST_ASSO = "/association/dashboard?tab=wallet";
export const DEST_USER = "/wallet";

export function destinationVersements({ assoAccount, user }) {
  if (assoAccount) return DEST_ASSO;
  if (user) return DEST_USER;
  return null;
}
